import { useState } from "react";
import { DefaultUser } from "../../common/icons";
import { DEFAULT_IMAGE } from "../../constants/blogs";

interface BlogCard {
  title: string;
  image: string;
  button: string;
  date: string;
  description: string;
  icon: string;
  author: string;
}

interface BlogProps {
  card: BlogCard;
  index?: number;
  slug?: string;
}

const NewsLetterCard = ({ card, slug }: BlogProps & { index?: number }) => {
  const [imageSrc, setImageSrc] = useState(card.image || DEFAULT_IMAGE);
  return (
    <a
      href={slug ? `/blogs-and-news/${slug}` : "#"}
      className="block bg-white rounded-[20px] border border-line p-2 mt-2 hover:shadow-lg transition-shadow duration-300"
    >
      <div className="relative">
        <img
          src={imageSrc}
          width="80"
          height="80"
          alt={card.title}
          className={`h-auto md:h-[200px] w-full rounded-[16px] ${
            imageSrc === DEFAULT_IMAGE ? "object-contain" : "object-cover"
          }`}
          onError={() => setImageSrc(DEFAULT_IMAGE)}
        />
      </div>
      <div className="px-4 flex flex-col items-start justify-start mt-3">
        <div className="flex items-center gap-4">
          <button className="h-[30px] rounded-[100px] bg-secondary-200 px-4 py-[2px] text-sm md:text-xs font-normal leading-[14px]">
            {card.button}
          </button>
          <div className="h-[1px] w-6 bg-gray-300"></div>
          <span className="text-sm md:text-xs font-normal leading-[14px] text-text">
            {card.date}
          </span>
        </div>
        <h1 className="mt-2 md:text-base text-md leading-[36px] font-medium md:leading-[21px] text-title md:h-[25px]">
          {card.title}
        </h1>
        <div className="mt-4 flex items-center gap-2">
          {card.icon !== null ? (
            <img
              src={card.icon}
              width="40"
              height="40"
              alt="author"
              className="h-[36px] w-[36px] rounded-full object-cover"
            />
          ) : (
            <DefaultUser className="h-[45px] w-[24px] rounded-full object-cover" />
          )}

          <span className="text-sm md:text-xs font-normal leading-[26px]">
            {card.author}
          </span>
        </div>
      </div>
    </a>
  );
};

export default NewsLetterCard;
